const removeDrafts = (productId?: string) => {
  if (!productId) return;
  return productId.replace(/^(drafts\.)/, '');
};

export default removeDrafts;
